import React, { FC } from 'react';
import cs from 'classnames';
import { useTranslation } from '@wix/wix-i18n-config';
import ChevronDown from '../../icons/ChevronDown.svg';
import { ChevronDown as HarmonyChevronDown } from '@wix/wix-ui-icons-common/odeditor';
import { useIsStudio2Ui } from '../../hooks/useIsStudio2Ui';

import MenuToggle from '../../icons/MenuToggle.svg';

import s from './MegaMenuToggleV2.scss';

interface MegaMenuToggleProps {
  isActive: boolean;
}

export const MegaMenuToggle: FC<MegaMenuToggleProps> = ({ isActive }) => {
  const { t } = useTranslation();
  const isStudio2Ui = useIsStudio2Ui();

  return (
    <div
      className={cs(s.toggle, {
        [s.active]: isActive,
      })}
      role="button"
    >
      <MenuToggle className={s.menuToggleIcon} />
      <span
        className={s.toggleLabel}
        data-text={t('app.topBar.v2.menu.toggle.label')}
      >
        {t('app.topBar.v2.menu.toggle.label')}
      </span>
      {isStudio2Ui ? (
        <HarmonyChevronDown className={s.arrowIcon} />
      ) : (
        <ChevronDown className={s.arrowIcon} />
      )}
    </div>
  );
};
